<template>
  <div class="filter">
    <div class="filter_form">
      <div class="level bottom">
        <div class="level-left">
          <b-field class="input_checkbox">
            <b-checkbox
              @input="
                rows.checked = []
                $emit('handle-change')
              "
              v-model="search.trashed"
              type="is-info"
            >
              Показать архивные
            </b-checkbox>
          </b-field>
        </div>
        <div class="level-right filter_actions">
          <button class="double_course" @click="$emit('duplicate')" :disabled="!rows.checked.length">
            <i class="mdi mdi-file-document-box-multiple-outline"></i> Дублировать курс (-ы)
          </button>
          <button
            class="delete_course"
            @click="$emit('delete')"
            :disabled="!rows.checked.length"
            v-if="!search.trashed"
          >
            <i class="mdi mdi-folder-remove-outline"></i> В архив
          </button>
          <button class="delete_course" @click="$emit('restore')" :disabled="!rows.checked.length" v-else>
            <i class="mdi mdi-folder-remove-outline"></i> Восстановить
          </button>
          <button class="add_course" @click="$emit('create-course')">
            <i class="mdi mdi-briefcase-plus-outline"></i> Создать курс
          </button>
        </div>
      </div>
      <form class="level" @submit.prevent="$emit('handle-change')">
        <b-field label="Поиск по категории:" type="is-info" class="course_select category_select">
          <b-select v-model="search.category_id" placeholder="Категория">
            <option :value="0">Категория</option>
            <option v-for="(category, i) in categoriesList" :key="i" :value="category.id">{{ category.name }}</option>
          </b-select>
        </b-field>
        <b-field label="Поиск по статусу:" type="is-info" class="course_select status_select">
          <b-select v-model="search.status" placeholder="Статус">
            <option :value="2">Статус</option>
            <option :value="1">Опубликован</option>
            <option :value="0">Черновик</option>
          </b-select>
        </b-field>
        <b-field label="Поиск по названию курса:" class="course_search input_search" type="is-info">
          <b-input placeholder="Поиск курсов" v-model="search.name"></b-input>
        </b-field>
        <b-field label="" class="course_search input_search with_button" type="is-info">
          <button type="submit">Поиск</button>
        </b-field>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    search: {
      default: () => {},
      type: Object
    },
    categoriesList: {
      default: () => [],
      type: Array
    },
    rows: {
      default: () => {},
      type: Object
    }
  },
  computed: {
    userRole() {
      return this.$store.state.auth.role[0]
    }
  }
}
</script>
